import defaultSchema from './default.schema';

export default {
  ...defaultSchema,
  properties: {
    woj: {
      title: 'Województwo',
      type: 'string',
      fieldRequired: false
    },
    pow: {
      title: 'Powiat',
      type: 'string',
      fieldRequired: false
    },
    gmi: {
      title: 'Gmina',
      type: 'string',
      fieldRequired: false
    },
    terc: {
      title: 'Kod TERC',
      type: 'string',
      fieldRequired: false
    },
    city: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: false
    },
    simc: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: false
    },
    street: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: false
    },
    ulic: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: false
    },
    postalCode: {
      title: 'Kod pocztowy',
      type: 'string',
      format: 'kod',
      fieldRequired: false,
      validationMessages: {
        format: 'Niepoprawny kod pocztowy'
      }
    },
    homeNumber: {
      title: 'Numer budynku',
      type: 'string',
      fieldRequired: false,
      maxLength: 500
    },
    localNumber: {
      title: 'Numer lokalu',
      type: 'string',
      fieldRequired: false,
      maxLength: 500
    }
  }
};
